"use client";

import { motion } from "framer-motion";
import { ReactNode, CSSProperties } from "react";

export function AnimatedPlatformCard({ 
  children, 
  className,
  style
}: { 
  children: ReactNode; 
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <motion.article
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      className={className}
      style={style}
    >
      {children}
    </motion.article>
  );
}
